declare global {
  interface DisyNamespace {
    readonly clientSessionId: string;
    readonly contextPath: string;
    readonly debug: boolean;
    readonly language: string;
    readonly locale: string;
  }
}

export function isDebug() {
  return getDisyNamespace().debug ?? false;
}

export function getDisyNamespace() {
  if (!('Disy' in window) || window.Disy == null) {
    throw new Error('The global Disy namespace is not defined');
  }
  return window.Disy as Partial<DisyNamespace>;
}

/** Returns the Disy namespace mutable, for testing */
export function __getDisyNamespace__() {
  return getDisyNamespace() as DeepMutable<DisyNamespace>;
}

/** The opposite of the built-in `Readonly` utility type, but recursive. */
export type DeepMutable<T> = { -readonly [P in keyof T]: DeepMutable<T[P]> };
